const subscribers = new Set();
let giftCandidateState = 'false';

const readFromLocalStorage = () => {
  if (typeof window === 'undefined') return giftCandidateState;
  const stored = window.localStorage.getItem('_giftCandidate');
  giftCandidateState = stored === 'true' ? 'true' : 'false';
  return giftCandidateState;
};

export const getGiftCandidateState = () => {
  const current = readFromLocalStorage();
  return current === 'true';
};

export const setGiftCandidateState = (value) => {
  const nextState = value ? 'true' : 'false';
  if (readFromLocalStorage() === nextState) {
    return;
  }

  giftCandidateState = nextState;

  if (typeof window !== 'undefined') {
    window.localStorage.setItem('_giftCandidate', giftCandidateState);
  }

  subscribers.forEach((callback) => {
    try {
      callback(giftCandidateState === 'true');
    } catch (error) {
      // console.warn('gift-candidate subscriber error', error);
    }
  });
};

export const subscribeToGiftCandidate = (callback) => {
  if (typeof callback !== 'function') return () => {};
  subscribers.add(callback);
  return () => {
    subscribers.delete(callback);
  };
};
